import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CircularProgress } from "@mui/material";
import { useLocation } from "react-router-dom";
import {
    Button,
    Stepper,
    Step,
    StepLabel,
    Typography,
    TextField,
} from "@mui/material";
import NavbarSidebarLayout from "../../../components/Dashboard/Layouts/NavbarSidebar";

import { api } from "../../../config/config";
import {Menu} from "../../../components/Menu/Menu";


const EditPersonnePhysique = () => {

    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();

    const [activeStep, setActiveStep] = useState(0);

    const [formData, setFormData] = useState({});

    const [errors, setErrors] = useState({});

    // deactiver le bouton submit lorsqu'on actionne le bouton soumettre
    const [stateSend, setStateSend] = useState(false);

    const steps = [
        "Recherche du client",
        "Mes informations",
        "Motif de ma demande",
    ];

    useEffect(()=>{

        setIsLoading(true);

        // Chercher une demande
        try {
            api.get(`/demande/${location.state.resiliationPhysiqueId}`).then(response => {
                if (response.status === 200){
                    setFormData(response.data.content);
                    setIsLoading(false);
                }
            }).catch(() => {
                setIsLoading(false);
                toast.warning("Erreur serveur.");
            })
        }catch (e) {

        }
    }, [location.state.resiliationPhysiqueId]);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setStateSend(false);
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleChange = (field, value) => {
        setFormData((prevData) => ({ ...prevData, [field]: value }));
    };

    const handleFieldFocus = (field) => {
        setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
    };

    // Validation des champs du formulaire
    const validateForm = (formData) => {
        const errors = {};
        if (activeStep === 2) {
            if (!formData.motif) {
                errors.motif = "Vueillez saisir le motif de la demande";
            }
        }
        return errors;
    };

    const handleDemande = () => {
        const validationErrors = validateForm(formData);
        if (Object.keys(validationErrors).length === 0) {

            setIsLoading(true);

            // On retire les champs qui n'ont pas été soumis pour validation
            const filteredDataMorale = Object.fromEntries(
                Object.entries(formData).filter(([key, value]) => value !== null)
            );

            // Soumettre la demande du client
            try {
                api
                    .put("/demande", filteredDataMorale)
                    .then((response) => {
                        if (response.status === 201) {
                            setFormData({
                                exploitation: "",
                                compteur: "",
                                motif: "",
                                rccm: "",
                                ifu: "",
                                police:"",
                                nom_entreprise: "",
                            });

                            toast.success(
                                "Demande modifiée avec succès."
                            );
                            setIsLoading(false);
                            setStateSend(true); // désactiver le bouton
                        }
                    })
                    .catch(() => {
                        toast.error("Demande modifiée");
                        setIsLoading(false);
                    });
            } catch (erreur) {

            }
        } else {
            setErrors(validationErrors);
        }
    };

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <div className="flex flex-col justify-center items-center space-y-5 mt-8 mb-8">
                        <>
                            {isLoading && <CircularProgress/>}
                            <div className="flex  flex-row space-x-8 ">
                                <TextField
                                    label="Numero compteur"
                                    fullWidth
                                    size="small"
                                    value={formData.numero_compteur}
                                    onChange={event => handleChange("numero_compteur",event.target.value )}
                                    InputLabelProps={{shrink: true}}
                                    disabled={true}
                                />
                                <TextField
                                    label="Numero de police"
                                    fullWidth
                                    size="small"
                                    value={formData.numero_police}
                                    onChange={event => handleChange("police",event.target.value )}
                                    InputLabelProps={{shrink: true}}
                                    disabled={true}
                                />
                            </div>
                            <div className="flex  flex-row space-x-8 ">
                                <TextField
                                    label="Nom"
                                    fullWidth
                                    size="small"
                                    value={formData.nom}
                                    onChange={event => handleChange("nom",event.target.value )}
                                    InputLabelProps={{shrink: true}}
                                    disabled={true}
                                />
                                <TextField
                                    label="Prenom"
                                    fullWidth
                                    size="small"
                                    value={formData.prenom}
                                    onChange={event => handleChange("prenom",event.target.value )}
                                    InputLabelProps={{shrink: true}}
                                    disabled={true}
                                />
                            </div>
                            <div className="flex  flex-row space-x-8 ">
                                <TextField
                                    label="Email"
                                    fullWidth
                                    size="small"
                                    value={formData.email}
                                    onChange={event => handleChange("email",event.target.value )}
                                    InputLabelProps={{shrink: true}}
                                    disabled={true}
                                />
                                <TextField
                                    label="Telephone"
                                    fullWidth
                                    size="small"
                                    value={formData.tel2}
                                    onChange={event => handleChange("tel",event.target.value )}
                                    InputLabelProps={{shrink: true}}
                                    disabled={true}
                                />
                            </div>
                            <div className="flex  flex-row space-x-8 ">
                                <TextField
                                    label="Section"
                                    fullWidth
                                    size="small"
                                    value={formData.section}
                                    onChange={event => handleChange("section",event.target.value )}
                                    InputLabelProps={{shrink: true}}
                                    disabled={true}
                                />

                                <TextField
                                    label="lot"
                                    fullWidth
                                    size="small"
                                    value={formData.lot}
                                    onChange={event => handleChange("lot",event.target.value )}
                                    InputLabelProps={{shrink: true}}
                                    disabled={true}
                                />
                            </div>
                            <div className="flex  flex-row space-x-8 ">
                                <TextField
                                    label="Parcelle"
                                    fullWidth
                                    size="small"
                                    value={formData.parcelle}
                                    onChange={event => handleChange("parcelle",event.target.value )}
                                    InputLabelProps={{shrink: true}}
                                    disabled={true}
                                />
                                <TextField
                                    label="Rang"
                                    fullWidth
                                    size="small"
                                    value={formData.rang}
                                    onChange={event => handleChange("rang",event.target.value )}
                                    InputLabelProps={{shrink: true}}
                                    disabled={true}
                                />
                            </div>
                        </>
                    </div>
                );

            case 1:
                return (
                    <div className=" space-y-5 mt-8 mb-8">
                        <TextField
                            label="Saisir le motif de la demande"
                            fullWidth
                            size="small"
                            value={formData.motif}
                            onChange={(e) => handleChange("motif", e.target.value)}
                            onFocus={() => handleFieldFocus("motif")}
                            InputLabelProps={{shrink: true}}
                            error={!!errors.motif}
                            helperText={errors.motif}
                        />
                    </div>
                );
            case 2:
                return (
                    <div className="flex flex-col justify-center items-center space-y-5 mt-8 mb-8 dark:text-white">
                        <Typography
                            className="text-center mb-8 dark:text-white"
                            variant="h5"
                        >
                            Voulez-vous vraiment modifier votre demande ?
                        </Typography>
                    </div>
                );

            default:
                return "Unknown step";
        }
    };

    return (
        <NavbarSidebarLayout>
            <div
                className="block items-center justify-center border-b border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex">
                <div className="mb-1 w-full">
                    <Menu titre="Modification de demande de résiliation personne physique"/>
                    <div className={`my-8`}>
                        <div className="text-center  text-3xl mb-8">
                            Modification de la résiliation personne physique
                        </div>

                        <div
                            className="flex w-full flex-col gap-y-6 lg:flex-row lg:justify-center lg:gap-y-0 md:flex-row md:justify-center md:gap-y-0">
                            <div
                                className=" rounded-lg bg-white p-2 shadow-2xl dark:bg-gray-800  xl:p-8 lg:w-1/2 border-2 lg:p-5">
                               <div className="invisible md:visible">
                    <Stepper activeStep={activeStep} alternativeLabel>
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{/*label*/}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </div>
                                <div>
                                    <Typography className="text-center mb-8" variant="h5">
                                        {steps[activeStep]}
                                    </Typography>
                                    {getStepContent(activeStep)}

                                    <div className="flex flex-row justify-between pt-18">
                                        <Button
                                            color="success"
                                            variant="outlined"
                                            disabled={activeStep === 0}
                                            onClick={handleBack}
                                            sx={{mr: 1}}
                                        >
                                            Précédent
                                        </Button>

                                        <div className="flex 1 1 auto"/>
                                        {activeStep === steps.length - 1 && (
                                            <>
                                                <Button
                                                    color="secondary"
                                                    variant="outlined"
                                                    onClick={handleDemande}
                                                    sx={{mr: 1}}
                                                    disabled={stateSend}
                                                >
                                                    {isLoading ?
                                                        <>
                                                            <CircularProgress color="primary" size="1rem" /> En
                                                            cours ...
                                                        </>
                                                        :
                                                        <>
                                                            Modifier
                                                        </>
                                                    }
                                                </Button>
                                            </>
                                        )}
                                        {activeStep !== steps.length - 1 && (
                                            <Button
                                                onClick={handleNext}
                                                variant="contained"
                                                color="success"
                                            >
                                                Suivant
                                            </Button>
                                        )}
                                    </div>
                                    <ToastContainer/>
                                    {stateSend && (
                                        <div className="bg-green-100 mt-12">
                                            {" "}
                                            <Link to="/dashboard"> Voir mes demandes</Link>{" "}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </NavbarSidebarLayout>
    );
// );
};

export default EditPersonnePhysique;
